import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "application-page-container" }
const _hoisted_2 = {
  key: 0,
  class: "ri-arrow-left-s-line back-icon"
}
const _hoisted_3 = { class: "application-page-content" }

import { ref } from 'vue';
import router from '@/router';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  appName: {
    type: String,
    required: true,
  },
  backPath: {
    type: String,
    default: '/application-center'
  }
},
  setup(__props) {

const showBackIcon = ref(false);

const props = __props;

const goback = () => {
  router.replace(props.backPath);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "application-page-title",
      onClick: goback,
      onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (showBackIcon.value = true)),
      onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (showBackIcon.value = false))
    }, [
      _createVNode(_Transition, { name: "slide-fade" }, {
        default: _withCtx(() => [
          (showBackIcon.value)
            ? (_openBlock(), _createElementBlock("i", _hoisted_2))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createElementVNode("div", {
        class: _normalizeClass(["card-title", { 'title-hover': showBackIcon.value }])
      }, _toDisplayString(__props.appName), 3)
    ], 32),
    _createVNode(_Transition, {
      name: "fade",
      appear: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ]),
      _: 3
    })
  ]))
}
}

})